import styled from "styled-components";

const Wrapper = styled.div`
  color: #302e38;
  font-family: Public Sans;
  margin-bottom: 4px;
  margin-top: 0px;
  transition: background 0.2s;
  padding: 0px 6px 0px 0px;
  display: flex;
  align-items: center;
  width: 100%;
`;

const Viewer = styled.span`
  font-family: "PUBLIC SANS";
  font-size: ${(props) => props.fontSize || "24px"};
  line-height: ${(props) => props.lineHeight || "32px"};
  color: #302e38;
  font-weight: ${(props) => props.fontWeight || "bold"};
  text-align: start;
  max-width: 95%;
  padding-top: 2px;
`;

const EditIcon = styled.img`
  height: 100%;
  visibility: hidden;
  ${Wrapper}:hover & {
    visibility: visible;
  }
`;

const ViewerLink = styled.a`
  color: #8066ff;
  font-size: 14px;
  color: #8066ff;
  line-height: 24px;
  text-decoration: underline;
  font-family: "Public Sans";
  font-weight: 400;
  white-space: nowrap;
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Editor = styled.input`
  background: #ffffff;
  font-size: ${(props) => props.fontSize};
  border: 1px solid #8066ff;
  box-sizing: border-box;
  border-radius: 4px;
  width: 100%;
  height: ${(props) => props.height};
`;

const ButtonMediumPrimary = styled.button`
  background: #8066ff;
  border: none;
  border-radius: 2px;
  color: white;
  cursor: pointer;
  font-family: Public Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  height: 48px;
  line-height: 24px;
  white-space: nowrap;
  padding: 8px 16px;
  transition: all 0.2s;
  margin-left: 5px;
  margin-right: 4px;
  :hover {
    background: #4d3aab;
  }
`;

export { Wrapper, EditIcon, Viewer, ViewerLink, Editor, ButtonMediumPrimary };
